import React, { useEffect, useState, useCallback } from 'react';

import AssignAgentSelector from 'modules/journey/AssignAgentSelector';
import { getJourneyOwner } from 'modules/tasks/http';

const t = {
  placeholder: 'No owner',
};

const AgentSearch = ({ value, setValue, idValue }) => {
  const [searchingOwner, setSearchingOwner] = useState(false);
  const disabled = !idValue || !idValue.value || searchingOwner;

  const handleSelectAgent = useCallback(
    ({ agent }) => {
      const { label, value } = agent || {};

      if (!agent) setValue(null);

      setValue({
        label,
        value,
      });
    },
    [setValue]
  );

  useEffect(
    function getDefaultOwner() {
      (async function () {
        if (!idValue || !idValue.value) return;
        setSearchingOwner(true);
        const owner = await getJourneyOwner(idValue.value);
        setValue(owner);
        setSearchingOwner(false);
      })();
    },
    [idValue, setValue]
  );

  return (
    <AssignAgentSelector
      placeholder={t.placeholder}
      value={value}
      onChange={handleSelectAgent}
      minWidth="136"
      filterUserGroups="ProdTech"
      onBlur={() => {
        /*noop*/
      }}
      autoFocus={false}
      disabled={disabled}
    />
  );
};

export default AgentSearch;
